import { WrapTags } from './WrapTags';

interface FlowHashtagTextProps {
  text: string;
  onTap: (tag: string) => void;
}

export function FlowHashtagText({ text, onTap }: FlowHashtagTextProps) {
  // Split on any run of whitespace (space, tab, newline, multiple
  // consecutive spaces collapsed) so this agrees with the backend's
  // strings.Fields-based hashtag scan in
  // backend/modules/channel/transitions/sharelink.go's channelTagList -
  // see that function's comment for the shared word-boundary rule.
  const tags = text.split(/\s+/).filter((word) => word.startsWith('#'));
  return (
    <div className="flex flex-col gap-2">
      <p className="m-0 whitespace-pre-wrap">{text}</p>
      <WrapTags tags={tags} onTap={onTap} />
    </div>
  );
}
